import SuggestWords from "./SuggestWords";
import SuggestProducts from "./SuggestProducts";

const FinalSearchSuggestion = ({
  clearSearch,
  products,
  inputValue,
  redirectToSearch,
  suggestions,
  handleSearch,
  queryID,
}) => {

  const handleMouseEnter = (word) => {
    handleSearch(word, true);
  };

  return (
    <>
      {(!!suggestions?.length || !!products?.length) && (
        <div className="grid grid-cols-5 max-[991px]:grid-cols-1 gap-2 p-3 ">
          <div className="col-span-1">
            <SuggestWords
              suggestions={suggestions}
              products={products}
              inputValue={inputValue}
              handleMouseEnter={handleMouseEnter}
              redirectToSearch={redirectToSearch}
              clearSearch={clearSearch}
            />
          </div>
          <div className="col-span-4">
            <SuggestProducts
              inputValue={inputValue}
              products={products}
              clearSearch={clearSearch}
              queryID={queryID}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default FinalSearchSuggestion;
